import { render } from "./ConfirmLogoutModal.vue?vue&type=template&id=8dbf9372"
import script from "./ConfirmLogoutModal.vue?vue&type=script&lang=js"
export * from "./ConfirmLogoutModal.vue?vue&type=script&lang=js"
script.render = render

export default script